import React from "react"
import {
  adressItemTitle,
  adressItemTitleNotClickable,
  adressMore,
  adressItemTaxo,
  adressItemTaxoContainer,
  adressDetails,
  adressTop,
} from "../styles/listAdresses.module.scss"
import { AdressItemTaxo } from "./styled-components/adresse-item-styled"
import PropTypes from "prop-types"
import TransitionFade from "../../../components/transition-fade"

const AdresseItem = ({
  adress,
  changeAdress,
  choosenAdress,
  initialAdress,
}) => (
  <>
    <div className={adressTop}>
      <p
        role="presentation"
        tabIndex="0"
        onClick={() => {
          if (adress.field_coordon) {
            changeAdress(adress, choosenAdress, adress.title, initialAdress)
          }
        }}
        onKeyDown={() => {
          if (adress.field_coordon) {
            changeAdress(adress, choosenAdress, adress.title, initialAdress)
          }
        }}
        className={
          adress.field_coordon &&
          adress.field_coordon?.lat !== choosenAdress?.field_coordon?.lat &&
          adress.field_coordon?.lon !== choosenAdress?.field_coordon?.lon
            ? adressItemTitle
            : adressItemTitleNotClickable
        }
      >
        {adress.title}
      </p>
      <TransitionFade className={adressMore} link={adress.path.alias}>
        Plus d&apos;infos
      </TransitionFade>
    </div>
    <div className={adressDetails}>
      <div className={adressItemTaxoContainer}>
        {adress.relationships.field_taxonomie_thematique
          ?.slice(0, 3)
          .map((element, index) => (
            <AdressItemTaxo key={index} className={adressItemTaxo}>
              {element.name}
            </AdressItemTaxo>
          ))}
      </div>
    </div>
  </>
)

AdresseItem.propTypes = {
  adress: PropTypes.object.isRequired,
  changeAdress: PropTypes.func,
  choosenAdress: PropTypes.object,
  initialAdress: PropTypes.object,
}

export default AdresseItem
